import { render, staticRenderFns } from "./PopularUser.vue?vue&type=template&id=cdf1e812&scoped=true&"
import script from "./PopularUser.vue?vue&type=script&lang=js&"
export * from "./PopularUser.vue?vue&type=script&lang=js&"
import style0 from "./PopularUser.vue?vue&type=style&index=0&id=cdf1e812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf1e812",
  null
  
)

export default component.exports